export const environment = {production: true , API:  "https://jcc-apirm.pcdocs.com.br/api"  , APIpublic:  "https://jcc-apirm.pcdocs.com.br/public/usuario" , AlfrescoAPI:  "https://jcc.pcdocs.com.br" , URL_SURFACE:  "https://jcc-surface.pcdocs.com.br/" , URL_WORKSPACE:  "https://jcc.pcdocs.com.br/" , URL_RM:  "https://jcc-rm.pcdocs.com.br/" }



// WEBPACK FOOTER //
// /app/src/environments/environment.ts